import { render, staticRenderFns } from "./PermissionsListFilters.vue?vue&type=template&id=768e9cb5&"
import script from "./PermissionsListFilters.vue?vue&type=script&lang=js&"
export * from "./PermissionsListFilters.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsListFilters.vue?vue&type=style&index=0&id=768e9cb5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports